import clsx from 'clsx'

// Официальная эмблема MAX из брендбука (https://go.max.ru/brandbook#logo).
// У эмблемы конический градиент — SVG-примитивами он не выражается, поэтому
// растр /img/maxIcon.png (120×120, хватает до 40px @3x).
let MaxIcon = ({ className }: { className?: string }) => (
  <svg
    className={clsx(className)}
    width='34'
    height='34'
    viewBox='0 0 34 34'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <image
      href='/img/maxIcon.png'
      xlinkHref='/img/maxIcon.png'
      width='34'
      height='34'
    />
  </svg>
)

export default MaxIcon
